import { render, staticRenderFns } from "./AcryApp.vue?vue&type=template&id=dafca38a"
import script from "./AcryApp.vue?vue&type=script&lang=js"
export * from "./AcryApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports